import Phaser from "phaser";
import timeBar from "@assets/imgs/game/time-bar.png";

export class TimeBar extends Phaser.GameObjects.Container {
  private bg: Phaser.GameObjects.Image;
  private fill: Phaser.GameObjects.Graphics;
  private hand: Phaser.GameObjects.Rectangle;

  private fillX: number;
  private fillY: number;
  private fillWidth: number;
  private fillHeight: number;

  static preload(scene: Phaser.Scene) {
    scene.load.image("time-bar", timeBar);
  }

  constructor(scene: Phaser.Scene, x: number, y: number) {
    super(scene, x, y);
    scene.add.existing(this);

    this.bg = scene.add.image(0, 0, "time-bar").setOrigin(0.5);
    this.add(this.bg);

    const paddingLeft = (this.bg.width * 57) / 639;
    const paddingRight = (this.bg.width * 14) / 639;
    const paddingVertical = (this.bg.height * 14) / 64;

    this.fillWidth = this.bg.width - paddingLeft - paddingRight;
    this.fillHeight = this.bg.height - paddingVertical * 2;

    this.fillX = -this.bg.width / 2 + paddingLeft;
    this.fillY = -this.fillHeight / 2;

    this.fill = scene.add.graphics();
    this.add(this.fill);

    this.hand = scene.add
      .rectangle(
        -this.bg.width / 2 + (this.bg.width * 30) / 639,
        0,
        4,
        this.bg.height - paddingVertical * 3.1,
        0x1c120e,
      )
      .setOrigin(0.5, 1);

    this.add(this.hand);

    this.setProgress(1);
  }

  /** 0~1 진행도에 따라 막대 + 바늘만 그린다 */
  setProgress(progress: number) {
    const p = Phaser.Math.Clamp(progress, 0, 1);

    this.fill.clear();

    if (p <= 0) {
      this.hand.setAngle(360);
      return;
    }

    this.fill.fillStyle(0xffd93d, 1);

    const radius = p <= 0.01 ? 0 : (this.fillHeight * 6) / 32;

    this.fill.fillRoundedRect(
      this.fillX,
      this.fillY,
      this.fillWidth * p,
      this.fillHeight,
      radius,
    );

    const elapsed = 1 - p;
    const angle = elapsed * 360;
    this.hand.setAngle(angle);
  }
}
